import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

export type FlagData = {
  enabled: boolean
  value: unknown
}
type Flags<T extends Array<string>> = Record<T[number], FlagData>

type UseFeatureFlagProps<T extends Array<string>> = {
  flagNames: [...T]
  forceEnabled?: boolean
}

type UseFeatureFlagReturn<T extends Array<string>> = {
  data: Flags<T>
  isLoading: boolean
}

const useFeatureFlags = <T extends Array<string>>({
  flagNames,
  forceEnabled = false,
}: UseFeatureFlagProps<T>): UseFeatureFlagReturn<T> => {
  const joinedFlagNames = flagNames.sort().join(',')
  const { data: response, isLoading } = useQuery<{ data: Flags<T> }>(
    ['featureFlags', joinedFlagNames],
    () => getJSON({ url: `/services/flagsmith/${joinedFlagNames}` })
  )

  // set default state
  let flags: Flags<T> = {} as any
  flagNames.forEach((flagName) => {
    flags[flagName] = {
      enabled: forceEnabled,
      value: undefined,
    }
  })
  if (!forceEnabled && response?.data) {
    flags = response.data
  }

  return {
    data: flags,
    isLoading,
  }
}

export default useFeatureFlags
